import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/modRollTime.css";

const ModRollTime = () => {
  const navigate = useNavigate();

  // Navigate to the Production Milestones page and auto-filter the Weekly Mod
  // Rolls table to the business week that contains the clicked date.
  // Adjust the route string below if your path differs (e.g. "/production/milestones").
  const handleRowClick = (date) => {
    navigate("/production-milestones", {
      state: { rollDate: date },
    });
  };

  return (
    <>
      <p className="modal-description">
        Time required to move units between stations
      </p>

      <div className="modal-section modal-section--scroll">
        <h3>Today's Line Rolls</h3>
        <div className="modal-table-scroll">
          <table className="modal-table modal-table--clickable modal-table--mod-roll-time">
            <thead>
              <tr>
                <th>Date/Time</th>
                <th>Roll Time (minutes)</th>
                <th>Unit Count</th>
                <th>Line Leader</th>
              </tr>
            </thead>
            <tbody>
              <tr
                className="modal-table-row--clickable"
                onClick={() => handleRowClick("2026-03-17")}
                title="Click for roll details"
              >
                <td>2026-03-17 07:30</td>
                <td>38</td>
                <td>20</td>
                <td>Matthew Johnson</td>
              </tr>
              <tr
                className="modal-table-row--clickable"
                onClick={() => handleRowClick("2026-03-17")}
                title="Click for roll details"
              >
                <td>2026-03-17 09:15</td>
                <td>45</td>
                <td>20</td>
                <td>Matthew Johnson</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="modal-section modal-section--scroll">
        <h3>Last 7 Business Days</h3>
        <div className="modal-table-scroll">
          <table className="modal-table modal-table--clickable modal-table--mod-roll-time">
            <thead>
              <tr>
                <th>Date</th>
                <th>Avg Roll Time (Minutes)</th>
                <th>Total Units</th>
                <th>Line Leader</th>
              </tr>
            </thead>
            <tbody>
              <tr
                className="modal-table-row--clickable"
                onClick={() => handleRowClick("2026-03-16")}
                title="Click for roll details"
              >
                <td>2026-03-16</td>
                <td>48</td>
                <td>40</td>
                <td>Matthew Johnson</td>
              </tr>
              <tr
                className="modal-table-row--clickable"
                onClick={() => handleRowClick("2026-03-13")}
                title="Click for roll details"
              >
                <td>2026-03-13</td>
                <td>52</td>
                <td>40</td>
                <td>Myriah Gass</td>
              </tr>
              <tr
                className="modal-table-row--clickable"
                onClick={() => handleRowClick("2026-03-12")}
                title="Click for roll details"
              >
                <td>2026-03-12</td>
                <td>46</td>
                <td>40</td>
                <td>Myriah Gass</td>
              </tr>
              <tr
                className="modal-table-row--clickable"
                onClick={() => handleRowClick("2026-03-11")}
                title="Click for roll details"
              >
                <td>2026-03-11</td>
                <td>51</td>
                <td>40</td>
                <td>Myriah Gass</td>
              </tr>
              <tr
                className="modal-table-row--clickable"
                onClick={() => handleRowClick("2026-03-10")}
                title="Click for roll details"
              >
                <td>2026-03-10</td>
                <td>49</td>
                <td>40</td>
                <td>Myriah Gass</td>
              </tr>
              <tr
                className="modal-table-row--clickable"
                onClick={() => handleRowClick("2026-03-9")}
                title="Click for roll details"
              >
                <td>2026-03-9</td>
                <td>44</td>
                <td>40</td>
                <td>Myriah Gass</td>
              </tr>
              <tr
                className="modal-table-row--clickable"
                onClick={() => handleRowClick("2026-03-10")}
                title="Click for roll details"
              >
                <td>2026-03-10</td>
                <td>53</td>
                <td>40</td>
                <td>Myriah Gass</td>
              </tr>
              <tr
                className="modal-table-row--clickable"
                onClick={() => handleRowClick("2026-03-09")}
                title="Click for roll details"
              >
                <td>2026-03-09</td>
                <td>47</td>
                <td>40</td>
                <td>Myriah Gass</td>
              </tr>
              <tr
                className="modal-table-row--clickable"
                onClick={() => handleRowClick("2026-03-06")}
                title="Click for roll details"
              >
                <td>2026-03-06</td>
                <td>50</td>
                <td>40</td>
                <td>Jose Casillas</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ModRollTime;
